const toOptIns = (raw) => {
  if (!raw) return [];
  return raw.reduce(
    (optInsArray, optIn) => [
      ...optInsArray,
      {
        id: optIn.id ?? "",
        literalText: optIn.literalText ?? "",
        value: optIn.value ?? false
      }
    ],
    []
  );
};
export {
  toOptIns
};
//# sourceMappingURL=opt-ins-mapper.js.map
